import { useEffect, useState } from "react";
import GritterNotification from "../gritternotification";
import { useOpenModal } from "../../customhooks";

import { SessionExpirationHandlerProps } from "./SessionExpirationHandler.types";
import { SessionExpiredModalStyled } from "./SessionExpirationHandler.styles";
import { LOCAL_STORAGE_CONSTANTS } from "../../constants";

const SessionExpirationHandler = (
  props: SessionExpirationHandlerProps
): JSX.Element => {
  const onOpenModal = useOpenModal();

  const { isShowNotification = false } = props;

  // State for session expiration notification
  const [showExpirationNotice, setShowExpirationNotice] = useState(false);
  const [timeLeftText, setTimeLeftText] = useState("");

  useEffect(() => {
    // Check token expiration time every second
    const checkTokenExpiration = (): void => {
      const refreshExpTimeInMilliSeconds = localStorage.getItem(
        LOCAL_STORAGE_CONSTANTS.refresh_exp_time_in_milli_seconds
      );

      if (refreshExpTimeInMilliSeconds) {
        const expirationTime = parseInt(refreshExpTimeInMilliSeconds, 10);
        const currentTime = Date.now();
        const timeLeftInSeconds = Math.floor(
          (expirationTime - currentTime) / 1000
        );

        // Show notification when 60 seconds or less are left
        if (timeLeftInSeconds <= 60 && timeLeftInSeconds > 0) {
          setShowExpirationNotice(true);

          // Format the time remaining as MM:SS
          const minutes = Math.floor(timeLeftInSeconds / 60);
          const seconds = timeLeftInSeconds % 60;
          const formattedTime = `${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

          setTimeLeftText(formattedTime);
        } else if (timeLeftInSeconds <= 0 && !isShowNotification) {
          // Token has expired
          // setShowExpirationNotice(false);
          onOpenModal({
            modalId: "session_expired_modal",
            visible: true,
          });
        } else {
          setShowExpirationNotice(false);
        }
      }
    };

    // Initial check
    checkTokenExpiration();

    // Set up interval to check continuously
    const intervalId = setInterval(checkTokenExpiration, 1000);

    // Clean up interval on component unmount
    return (): void => clearInterval(intervalId);
  }, []);

  return (
    <SessionExpiredModalStyled>
      {isShowNotification && showExpirationNotice && (
        <GritterNotification
          message={
            <>
              Your session is about to expire. You'll be logged out in{"  "}
              <span className="timer">00:{timeLeftText}</span>
              {"  "}
              seconds.
            </>
          }
          showIcon
          type="warning"
        />
      )}
    </SessionExpiredModalStyled>
  );
};

export default SessionExpirationHandler;
